import { ErrorBody, JOGGResponse } from "@jog/types"
import { v4 } from "uuid"

import { sleep } from "../helper"
import { getTwProfilekey, localStorage } from "../localStorage"

export class JogError<T = any> extends Error {
    constructor(
        message: string,
        public response: Omit<Response, "json"> & { json: () => Promise<ErrorBody<T>> }
    ) {
        super(message)
    }
}
export const AWSClient = (_baseUrl: string) => {
    const baseUrl = _baseUrl.replace(/\/$/, "")
    return async <T = any>({
        uri,
        ...request
    }: Omit<RequestInit, "body"> & {
        uri: string
        body?: any
    }): Promise<JOGGResponse<T>> => {
        const headers: {
            ["x-correlation-id"]: string
            ["x-tw-profilekey"]: string
            Authorization?: string
        } = { ["x-correlation-id"]: "", ["x-tw-profilekey"]: "" }
        if (typeof window !== "undefined") {
            const correlationId = localStorage.getItem<{ id: string }>("x-correlation-id", { id: "" })?.id
            if (!correlationId) {
                const newId = v4()
                localStorage.setItem<{ id: string }>("x-correlation-id", { id: newId })
                headers["x-correlation-id"] = newId
            } else {
                headers["x-correlation-id"] = correlationId
            }
            headers["x-tw-profilekey"] = getTwProfilekey() || ""
            const token = localStorage.getItem("cognito-auth")
            if (token) {
                headers["Authorization"] = `Bearer ${token}`
            }
        }
        const response = await fetch(`${baseUrl}${uri}`, {
            ...request,
            body: request.body ? JSON.stringify(request.body) : null,
            headers: request.headers ? { ...request.headers, ...headers } : headers,
        })
        if (response.ok) {
            return {
                ...response,
                body: response.status === 204 ? null : await response.json(),
                statusCode: response.status,
            }
        }
        if ([401, 403].includes(response.status)) {
            window.location.href = "/login"
            await sleep(5000)
        }
        throw new JogError(response.statusText, response)
    }
}
